import styled from 'styled-components'
import { BaseInput } from './BaseInput'

export const NumberInput = styled(BaseInput)`
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type='number'] {
    -moz-appearance: textfield;
  }
`
